import Model from "./base/model";

class BillingPlanValue extends Model{
  resourceName() {
    return "billing_plan_values";
  }

  fields() {
    return {
      price: "",
      plan_id: "",
    }
  }
}

export default new BillingPlanValue();
